var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invoices" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h3", { staticClass: "page-title" }, [
                    _vm._v("Wallet Connect")
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("Wallet Accounts")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-auto float-right ml-auto" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn add-btn",
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.connectToWallet }
                    },
                    [
                      _c("i", { staticClass: "la la-cloud" }),
                      _vm._v(" Connect Account\n              ")
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "row" }, [[_vm._m(0)]], 2)
              ])
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 col-lg-4 col-xl-4 d-flex" }, [
      _c("div", { staticClass: "leave-info-box card flex-fill" }, [
        _c("div", { staticClass: "row align-items-center mt-3" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-3 text-center" }, [
                _c(
                  "a",
                  {
                    staticClass: "squared",
                    attrs: { href: "javascript:void(0)" }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        alt: "",
                        src: require("@/assets/wallets/eth.png")
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-9" }, [
                _c("h4", [
                  _vm._v(
                    "\n                              ETH\n                            "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text-sm text-muted" }, [
                  _vm._v("Address: xx")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-left" }, [
              _c("div", { staticClass: "media-body" })
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table table-striped" }, [
              _c("tr", [
                _c("td", { staticStyle: { width: "40%" } }, [
                  _vm._v("Balance")
                ]),
                _vm._v(" "),
                _c("td", [_vm._v("10 ETH")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-right text-muted" }, [
              _c("small", [_vm._v("Last Updated: ")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04df06b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04df06b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/walletconnect/list.vue
// module id = null
// module chunks = 